export default {
  isEnabled: false,
  defaultTickInterval: 60,
  defaultNotificationDuration: 5 * 60,
  defaultMaxInactivity: 30 * 60,
};
